import './style.scss';
import { parallaxInit, zoomInInit } from './utils/functions';

document.addEventListener('DOMContentLoaded', () => {
	const els = document.querySelectorAll('.wp-block-evb-background');
	els.forEach(el => {
		const attributes = JSON.parse(el.dataset.attributes);
		const { wrapper } = attributes;
		const { animation = {} } = wrapper;
		const { type: aniType = 'none', parallax = {} } = animation;

		const bgEl = el.querySelector('.evbBackground');

		if ('parallax' === aniType && bgEl) {
			parallaxInit(bgEl, parallax, el);

			document.addEventListener('scroll', () => {
				parallaxInit(bgEl, parallax, el);
			});
		}
		if ('zoomIn' === aniType && bgEl) {
			zoomInInit(bgEl, el);

			document.addEventListener('scroll', () => {
				zoomInInit(bgEl, el);
			});
		}

		el.removeAttribute('attributes');
	});
});